import { useState } from "react";
import { useFetch } from "../../../common/hooks/useFetch";
import Swal from "sweetalert2";
import { createWorkRoutesListService } from "../service/createWorkRoutesList.service";

const initialState = {
  id: null,
  document: null,
  date: "",
};

export const useWorkRoutesListCommand = (refresh) => {
  const fetchData = useFetch();
  const [workRoutesList, setWorkRoutesList] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({ hasErrors: false, errors: {} });

  const handleChange = ({ name, value }) => {
    setWorkRoutesList((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      hasErrors: false,
      errors: {
        ...prev.errors,
        [name]: null,
      },
    }));
  };

  const createWorkRoutesList = async () => {
    setLoading(true);
    try {
      if (!validations(workRoutesList)) {
        return;
      }

      const formData = new FormData();
      formData.append("date", workRoutesList.date);
      formData.append("file", workRoutesList.document);

      const response = await createWorkRoutesListService(fetchData)(formData);

      Swal.fire({
        title: "Éxito",
        text: "La lista de rutas de trabajo se creó correctamente.",
        icon: "success",
      });
      setWorkRoutesList(initialState);
      refresh?.();
      return response;
    } catch (error) {
      console.error("Error creating work routes list:", error);
      setErrors({
        hasErrors: true,
        errors: error.response?.data || {
          general: "An error occurred while creating the work routes list.",
        },
      });
    } finally {
      setLoading(false);
    }
  };

  const validations = (data) => {
    const newErrors = {};
    if (!data.date) {
      newErrors.date = "Date is required.";
    }
    if (!data.document) {
      newErrors.document = "Document is required.";
    }
    if (
      data.document &&
      ![
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "text/csv",
      ].includes(data.document.type)
    ) {
      newErrors.document = "El archivo debe ser un Excel o CSV.";
    }
    const hasErrors = Object.keys(newErrors).length > 0;
    setErrors({
      hasErrors,
      errors: newErrors,
    });
    return !hasErrors;
  };

  return {
    workRoutesList,
    loading,
    errors,
    handleChange,
    createWorkRoutesList,
  };
};
